import React, { useState } from 'react';
import { Auth } from 'aws-amplify';
import { v4 as uuidv4 } from 'uuid';
import { stringifyAddressObject } from 'components/HGForm/helpers';
import HGForm from 'components/HGForm';

const CompanyForm = ({ setNewUser }) => {
    const [errorMessage, setErrorMessage] = useState('');
    const UUID = uuidv4();

    const signUp = async (creds) => {
        setErrorMessage(null);
        try {
            const {
                companyName,
                firstName,
                lastName,
                email,
                password,
                phone,
                address: addressObject,
            } = creds;
            const address = stringifyAddressObject(addressObject);
            const newUserCredentials = {
                username: email,
                password,
                attributes: {
                    address,
                    email,
                    name: firstName,
                    family_name: lastName,
                    phone_number: '+' + phone,
                    'custom:company_name': companyName,
                    'custom:company_id': UUID,
                    'custom:company_admin_id': UUID,
                    'custom:role': 'CompanyAdmin',
                },
            };

            const user = await Auth.signUp(newUserCredentials);
            if (user) setNewUser(user);
        } catch (error) {
            error.message = error.message.replace(
                'PreSignUp failed with error',
                ''
            );
            setErrorMessage(error.message);
        }
    };

    return (
        <HGForm
            fields={{
                companyName: 'Company Name',
                email: 'Email',
                phone: 'Phone',
                address: 'Address',
                firstName: 'First Name',
                lastName: 'Last Name',
                password: 'Password',
                confirmPassword: 'Confirm Password',
            }}
            buttonText="create account"
            handleSubmit={signUp}
            errorMessage={errorMessage}
        />
    );
};
export default CompanyForm;
